import React from 'react';
import { IBaseActionButtonProps } from '../interfaces';
import BaseActionButton from '../BaseActionButton';
import useStyles from './styles';
import { ReactComponent as EditIcon } from '../../../../assets/icons/editIcon.svg';

const EditActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <EditIcon className={classes.icon} />
    </BaseActionButton>
  );
};

export default EditActionButton;
